import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { napster } from '../util';
import SongList from './SongList';
import ArtistList from './ArtistList';

const ArtistsTab = () => {
  const { query } = useParams();
  const [trackList, setTrackList] = useState(Array(20).fill(-1));
  const [offset, setOffset] = useState(0);
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    if(query === undefined || query === "") {
      setTrackList([]);
      setShowMore(false);
      return;
    }
    setTrackList(Array(20).fill(-1));
    setOffset(0);
    (async _ => {
      try {
        // Returns an array of typed results by substring.
        // /v2.2/search?query=weezer&per_type_limit=5&offset=5
        const response = await napster.get(`/search?query=${query}&type=artist&per_type_limit=20&offset=0`);
        setTrackList(response.data.search.data.artists);
        setOffset(20);
        setShowMore(true);
      } catch(e) {
        setTrackList([]);
      }
    })();
  }, [query]);

  const loadMore = () => {
    const oldState = trackList;
    setTrackList(e => [...e, ...(Array(20).fill(-1))]);
    (async _ => {
      // Returns an array of typed results by substring.
      // /v2.2/search?query=weezer&per_type_limit=5&offset=5
      const response = await napster.get(`/search?query=${query}&type=artist&per_type_limit=20&offset=${offset}`);
      if (response.data.search.data.artists=== 0) {
        setShowMore(false);
      }
      setTrackList([...oldState, ...response.data.search.data.artists]);
      setOffset(e => e + 20);
    })();
  }

  return (
    <>
      <ArtistList list={trackList} loadMore={loadMore} showLoadMore={showMore}  horizontal={false} />
    </>
  )
}

export default ArtistsTab